export const getUniqueDeviceId = () => {
    let deviceId = localStorage.getItem('unique_device_id');

    if (!deviceId) {
        // Cihazı tekilleştirmek için benzersiz bir ID oluşturur
        deviceId = 'device_' + Math.random().toString(36).substring(2, 15) + '_' + Date.now();
        localStorage.setItem('unique_device_id', deviceId);
    }

    return deviceId;
};

export const getPlatformInfo = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();

    const isIos = /iphone|ipad|ipod/.test(userAgent.toLowerCase());


    // Uygulamanın tarayıcıda mı yoksa Ana Ekrana eklenmiş (PWA) halde mi olduğunu kontrol eder
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
        || (window.navigator && window.navigator.standalone);

    return {
        // Eğer cihaz iOS ise backend'e "web_ios" bilgisini gönderir
        platform: isIos ? "web_ios" : "android",
        deviceId: getUniqueDeviceId(),
        isIos,
        isStandalone
    };
};